import React from "react";
import { Header } from "@/components/site/Header";
import { Contact } from "@/components/site/Contact";
import { FAQ } from "@/components/site/FAQ";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES, INSTITUT_CONTENT } from "@/data/content";
import { useSeo } from "@/hooks/useSeo";

export default function Institut() {
  useSeo({
    title: "L'Institut — Ninaa Beauty",
    description:
      "Découvrez l'univers de Ninaa Beauty : un institut intimiste dédié à la beauté et au bien-être, sa philosophie et sa fondatrice.",
    path: "/institut",
  });

  const c = INSTITUT_CONTENT;

  return (
    <div className="App" data-testid="institut-page">
      <Header />
      <main className="page-enter bg-[#faf7f2]">
        <div className="max-w-3xl mx-auto px-6">
          {/* L'institut — présentation avec photo intégrée en bas à droite */}
          <section
            data-testid="institut-story"
            className="pt-8 md:pt-12 pb-16 md:pb-20"
          >
            <Reveal>
              <h1 className="font-serif-display font-light text-[#4b2018] text-4xl md:text-5xl mb-8">
                L&apos;Institut
              </h1>
              <div className="md:grid md:grid-cols-2 md:gap-12 md:items-center">
                <div className="space-y-5 text-base md:text-lg leading-relaxed text-[#4b2018]">
                  {c.institut.map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
                <figure
                  data-testid="institut-photo"
                  className="mt-10 md:mt-0 mx-auto md:mx-0 w-full max-w-[520px] md:max-w-none shrink-0 overflow-hidden rounded-xl aspect-[4/3]"
                >
                  <img
                    src={IMAGES.institut}
                    alt="La cabine de l'institut Ninaa Beauty"
                    loading="lazy"
                    style={{ filter: "sepia(0.10) saturate(1.05) brightness(1.02) contrast(1.01)" }}
                    className="h-full w-full object-cover"
                  />
                </figure>
              </div>
            </Reveal>
          </section>

          <div className="mx-auto h-px w-16 bg-[#e6ddce]" />

          {/* Une approche qui considère l'ensemble */}
          <section
            data-testid="institut-approche"
            className="pt-16 md:pt-20 pb-16 md:pb-24"
          >
            <Reveal>
              <div className="md:grid md:grid-cols-[300px_1fr] md:gap-12 md:items-center">
                <div className="md:order-2">
                  <h2 className="font-serif-display font-light text-[#4b2018] text-3xl md:text-4xl mb-8">
                    {c.approcheTitle}
                  </h2>
                  <div className="space-y-5 text-base md:text-lg leading-relaxed text-[#4b2018]">
                    {c.approche.map((p, i) => (
                      <p key={i}>{p}</p>
                    ))}
                  </div>
                </div>
                <figure
                  data-testid="approche-art"
                  className="mt-10 md:mt-0 md:order-1 mx-auto w-full max-w-[300px] overflow-hidden rounded-xl"
                >
                  <img
                    src={IMAGES.approcheArt}
                    alt="Illustration douce — prendre soin de soi, un jour après l'autre"
                    loading="lazy"
                    className="w-full h-auto"
                  />
                </figure>
              </div>
            </Reveal>
          </section>

          {/* Qui suis-je ? */}
          <section
            data-testid="institut-founder"
            className="pt-8 pb-24 md:pb-32"
          >
            <Reveal>
              <h2 className="font-serif-display font-light text-[#4b2018] text-3xl md:text-4xl mb-10">
                {c.quiTitle}
              </h2>
            </Reveal>

            <Reveal delay={0.05}>
              <figure
                data-testid="founder-photo"
                className="mx-auto mb-10 max-w-[190px] overflow-hidden rounded-md aspect-[3/4]"
              >
                <img
                  src={c.founderImage}
                  alt="Nina, esthéticienne et fondatrice de Ninaa Beauty"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </figure>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="space-y-5 text-base md:text-lg leading-relaxed text-[#4b2018]">
                {c.qui.map((p, i) => (
                  <p
                    key={i}
                    className={
                      i === c.qui.length - 1
                        ? "pt-2 font-serif-display italic text-lg md:text-xl text-[#904234]"
                        : undefined
                    }
                  >
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>
          </section>
        </div>

        {/* FAQ — en bas de page, avant le contact */}
        <FAQ />
      </main>
      <Contact />
    </div>
  );
}
